import React from 'react'
import { useSelector } from 'react-redux'
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom'

//UI
import MainLayout from '@/components/Layout/MainLayout'

//State

import { authSelector } from '@/stores/auth/authSlice'
import { loadingOverlaySelector } from '@/stores/ui/loadingOverlaySlice'

import config, { APP_MODE } from '@/config'
import privateRoutes from '../PrivateRoutes/index.jsx'

const PrivateRouteMiddleware = () => {
  const { isAuthenticated, user } = useSelector(authSelector)
  const { show: showLoadingOverlay, text: loadingText } = useSelector(loadingOverlaySelector)

  const navigate = useNavigate()
  const location = useLocation()

  const params = new URLSearchParams(location.search)
  const loginCode = params.get('code')
  const isProduction = config.mode == APP_MODE.PRODUCTION

  if (!isAuthenticated && !loginCode) {
    // toast.error('You need to be logged in to access this page')
    return <Navigate to={isProduction ? '/auth/login' : '/external/auth/login'} state={{ from: location }} />
  } else if (!isAuthenticated && loginCode) {
    return <Navigate to={`/auth/login?code=${loginCode}`} state={{ from: location }} />
  }

  return (
    <MainLayout routes={privateRoutes}>
      <Outlet />
    </MainLayout>
  )
}

export default PrivateRouteMiddleware
